import React, { useEffect, useRef } from 'react';
import { Dialog, T } from '@colonist/ui';
export function ProfileDialog({ open, onClose, username, showBackButton, onBack, onMount, onDialogClosed }) {
    const prevOpenRef = useRef(open);
    useEffect(()=>{
        if (prevOpenRef.current && !open) {
            onDialogClosed();
        }
        prevOpenRef.current = open;
    }, [
        open
    ]);
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "lg"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, {
        onBack: showBackButton ? onBack : undefined
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:profilePage.dialogTitle",
        options: {
            username: username
        }
    })), /*#__PURE__*/ React.createElement(Dialog.LegacyContent, {
        key: username,
        onMount: onMount
    }));
}
